/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Agent_Same_SchemaInputs */

const en_directory_submit_content_agent_same_schema = /** @type {(inputs: Directory_Submit_Content_Agent_Same_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-assisted uses this same form`)
};

const zh_directory_submit_content_agent_same_schema = /** @type {(inputs: Directory_Submit_Content_Agent_Same_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 辅助也使用这份表单`)
};

/**
* | output |
* | --- |
* | "Agent-assisted uses this same form" |
*
* @param {Directory_Submit_Content_Agent_Same_SchemaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_agent_same_schema = /** @type {((inputs?: Directory_Submit_Content_Agent_Same_SchemaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Agent_Same_SchemaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_agent_same_schema(inputs)
	return zh_directory_submit_content_agent_same_schema(inputs)
});
export { directory_submit_content_agent_same_schema as "directory.submit.content.agent_same_schema" }